module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Front-Runner-The.21b0d5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Front-Runner-The.jpg
// module id = 50Bq
// module chunks = 0